import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadMore: {
		id: 'project-create-importer-upload-flow.common.custom-select-components.load-more',
		defaultMessage: 'Loading...',
		description: 'Text for loading more data',
	},
	tryAgain: {
		id: 'project-create-importer-upload-flow.common.custom-select-components.try-again',
		defaultMessage: 'Try again',
		description: 'Text for button to retrieve data again',
	},
});
